module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("CONTENTS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Introduction")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("1. ")]), _c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Kai Sweet Potato Pie")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/lovingallofme"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Loving All of Me")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("2. ")]), _c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("La’s Stuffed Beefless-Philly Portobello")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/sugaraintsosweet",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sugar Ain’t So Sweet")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("3. ")]), _c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Jamaican Style Oxtails")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor20daysofpleasure",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("20 Days of Pleasure")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("4. ")]), _c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Shrimp & Grits")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/hisbiggestfan",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("His Biggest Fan")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("5. ")]), _c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Spicy Barbecue Wings")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/heavencanbehell",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Heaven Can Be Hell")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("6. ")]), _c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Five Alarm Chili")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/seasonoftheblood",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Season of the Blood")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("7. ")]), _c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sweet Egg Loaf Soufflé")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/alphawarlocksclaim",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Alpha Warlock’s Claim")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("8. ")]), _c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Glazed Turkey Ham")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/thethingsicouldtellyou",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Things I Could Tell You")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("9. ")]), _c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Brunswick Stew")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/inservicetothesenator",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("In Service to the Senator")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("10. ")]), _c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("S.L.’s Thai Spring Rolls")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/sljennings",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("S. L. Jennings")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("11. ")]), _c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Struffuli")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/wingsofair",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Wings of Air")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("12. ")]), _c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Koeksisters")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/thesweettreatoflove",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Sweet Treat of Love")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("13. ")]), _c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Fudgy Mint Brownies")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/fromashes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("From Ashes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("14. ")]), _c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Fruit Salad Supreme")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/theunpinkable",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The UnPinkable")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("15. ")]), _c('span', {
    attrs: {
      "href": "#/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Screwdriver")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/toloveloveagainmalachisreprise",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("To Love & Love Again - Malachi’s Reprise")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("16. ")]), _c('span', {
    attrs: {
      "href": "#/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Mussels in White Wine")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/atfirstsight",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("At First Sight")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("17. ")]), _c('span', {
    attrs: {
      "href": "#/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("LINGUINE CON POLLO E FUNGHI")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/cysgodion",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Cysgodion")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("18. ")]), _c('span', {
    attrs: {
      "href": "#/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Grandma’s Caramel Cake")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/stilllifewithlobster",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Still Life with Lobster")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("19. ")]), _c('span', {
    attrs: {
      "href": "#/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Nanaimo Bars")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/merrylittlethings",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Merry Little Things")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("20. ")]), _c('span', {
    attrs: {
      "href": "#/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Nana’s Favorite Fudge")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/bebravewithme",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Be Brave With Me")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("21. ")]), _c('span', {
    attrs: {
      "href": "#/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Chess Pie")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/geminirising",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Gemini Rising")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("22. ")]), _c('span', {
    attrs: {
      "href": "#/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("German Meatballs")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/oncebitten",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Once Bitten")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 63
// module chunks = 0